import type { ExampleInputDescription } from '@/core/types';
import { registerExamples } from '../register';
import data from './data.json';
import schema from './schema.json';
import uischema from './uischema.json';
import config from './config.json';

export const input: ExampleInputDescription = {
  schema,
  uischema,
  data,
  config,
};

registerExamples([
  {
    name: 'array-type',
    label: 'Array Type',
    input,
  },
]);
